/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';

export default class ProxyDetail extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare proxyUrl: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'standalone/proxy-detail': ProxyDetail;
  }
}
